__turbopack_context__.v({
  "buttons": "PairingWheelOverlay-module-scss-module__Lt9JhG__buttons",
  "closeButton": "PairingWheelOverlay-module-scss-module__Lt9JhG__closeButton",
  "content": "PairingWheelOverlay-module-scss-module__Lt9JhG__content",
  "copy": "PairingWheelOverlay-module-scss-module__Lt9JhG__copy",
  "eyebrow": "PairingWheelOverlay-module-scss-module__Lt9JhG__eyebrow",
  "fade-in": "PairingWheelOverlay-module-scss-module__Lt9JhG__fade-in",
  "headline": "PairingWheelOverlay-module-scss-module__Lt9JhG__headline",
  "image": "PairingWheelOverlay-module-scss-module__Lt9JhG__image",
  "imageContainer": "PairingWheelOverlay-module-scss-module__Lt9JhG__imageContainer",
  "isOpen": "PairingWheelOverlay-module-scss-module__Lt9JhG__isOpen",
  "pairAgainButton": "PairingWheelOverlay-module-scss-module__Lt9JhG__pairAgainButton",
  "root": "PairingWheelOverlay-module-scss-module__Lt9JhG__root",
});
